import React from 'react';
import { Pricing } from './Pricing';
import { UrgencyModule } from './UrgencyModule';
export function FinalCta() {
  return <div className="bg-cream pt-6 md:pt-10" data-id="element-108">
      <div className="text-center px-4 mb-4 md:mb-6" data-id="element-109">
        <h2 className="text-2xl md:text-4xl font-bold font-serif text-teal-900 leading-tight" data-id="element-110">
          No dejes pasar esta oportunidad
        </h2>
      </div>
      <UrgencyModule data-id="element-111" />
      <Pricing id="final-pricing" showUrgency={false} data-id="element-112" />
    </div>;
}